import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import store from './hooks/local/store';
import { CartProvider } from './components/cartContext';
import { ThemeProvider } from './components/themeContext';

// Suppress ResizeObserver loop errors (harmless but noisy in development)
const originalError = console.error;

console.error = (...args) => {
  const errorMessage = args[0]?.toString() || '';

  if (
    errorMessage.includes('ResizeObserver loop') ||
    errorMessage.includes(
      'ResizeObserver loop completed with undelivered notifications',
    )
  ) {
    return;
  }

  originalError.call(console, ...args);
};

// Suppress ResizeObserver errors at the window level to prevent React error overlay
window.addEventListener('error', (e) => {
  if (
    e.message ===
      'ResizeObserver loop completed with undelivered notifications' ||
    e.message === 'ResizeObserver loop limit exceeded' ||
    e.message.includes('ResizeObserver loop')
  ) {
    e.stopImmediatePropagation();
    e.preventDefault();
    return false;
  }
});

// Also handle unhandled promise rejections that might contain ResizeObserver errors
window.addEventListener('unhandledrejection', (e) => {
  if (
    e.reason?.message?.includes('ResizeObserver loop') ||
    e.reason?.toString().includes('ResizeObserver loop')
  ) {
    e.stopImmediatePropagation();
    e.preventDefault();
  }
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <ThemeProvider>
        <CartProvider>
          <App />
        </CartProvider>
      </ThemeProvider>
    </Provider>
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
